
const $dateRange = $('.js-date-range');

if ($dateRange.length) {
    const $dateFilter = $('.js-date-filter');
    const $dateStart = $('.js-date-start');
    const $dateEnd = $('.js-date-end');
    const $selectedDateFrom = $('.js-selected-date-from');
    const $selectedDateTo = $('.js-selected-date-to');

    /* Локализация на русский */
    $.datepicker.regional.ru = {
        closeText: "Закрыть",
        prevText: "&#x3C;Пред",
        nextText: "След&#x3E;",
        currentText: "Сегодня",
        monthNames: [ "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь","Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь" ],
        monthNamesShort: [ "Янв", "Фев", "Мар", "Апр", "Май", "Июн","Июл", "Авг", "Сен", "Окт", "Ноя", "Дек" ],
        dayNames: [ "воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота" ],
        dayNamesShort: [ "вск", "пнд", "втр", "срд", "чтв", "птн", "сбт" ],
        dayNamesMin: [ "Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб" ],
        weekHeader: "Нед",
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    };

    $.datepicker.setDefaults($.datepicker.regional[App.H.attr('lang')]);

    $dateRange.datepicker({
        range: 'period', // режим - выбор периода
        numberOfMonths: 1,
        showOtherMonths: true,
        selectOtherMonths: true,
        onSelect: function(dateText, inst, extensionRange) {
            // extensionRange - объект расширения
            $dateStart.val(extensionRange.startDateText);
            $dateEnd.val(extensionRange.endDateText);
            $dateFilter.addClass('_selected');

            $selectedDateFrom.html(extensionRange.startDateText);
            $selectedDateTo.html(extensionRange.endDateText);
        }
    });

    // объект расширения (хранит состояние календаря)
    let extensionRange = $dateRange.datepicker('widget').data('datepickerExtensionRange');

    if (extensionRange.startDateText) {
        $dateStart.val(extensionRange.startDateText);
    }

    if (extensionRange.endDateText) {
        $dateEnd.val(extensionRange.endDateText);
    }

    $('.js-clear-datepicker').on('click', function () {
        $dateStart.val();
        $dateEnd.val();
        $dateFilter.removeClass('_selected');
        $dateRange.datepicker().datepicker('setDate', 'today');

        /* Событие в NewsPage.js */
        App.W.trigger('news:filter');
    });
}




// WEBPACK FOOTER //
// ./_src/js/UI.js